export default {
  en: {
    title: 'Administrators',
    subtitle: 'List of administrators have access to users, departments, integration and metrics.',
    columns: {
      name: 'Full Name',
      email: 'Email',
    },
    form: {
      firstname: {
        error: 'Please fill the first name of administrator.',
        help: 'This is the first name of administrator.',
      },
      lastname: {
        error: 'Please fill the last name of administrator.',
        help: 'This is the last name of administrator.',
      },
      email: {
        error: 'Please fill the email of administrator.',
        help: 'Enter the email or username that your administrator will access, remember that a username (not email) will not be able to recover the password by mail link.',
      },
      password: {
        error: 'The password must be at least 6 characters.',
        help: 'If you don\'t set a password, we send a link to email for change the password. ¡Remember use a valid email!',
        create: 'Create a password',
      },
      privilege: {
        error: 'Select a privilege for the administrators.',
        help: 'This define the permissions of administrators. Can be default or customized.',
      },
      passwordConfirm: {
        error: 'The passwords does not match.',
      },
    },
    notification: {
      success: {
        patch: 'The administrator {email} was edited successful.',
        post: 'The administrator {email} was created successful | The {email} was created successful, we send email for set activate account.',
      },
      fail: {
        conflict: 'The email or username is already used, please choose another.',
        username: 'If you don\'t set a password provide a valid email.\n\n On the contrary case please provide a password and username.',
      },
      permissions: 'Your don\'t have permissions to {action} administrators. If you believe this is wrong try again or contact us.',
    },
  },
  es: {
    title: 'Administradores',
    subtitle: 'Lista de administradores que tienen acceso a crear usuarios, departamentos, integración y métricas.',
    columns: {
      name: 'Nombre',
      email: 'Correo electrónico',
    },
    form: {
      firstname: {
        error: 'Por favor llene el nombre del administrador.',
        help: 'Este es el primer nombre del administrador.',
      },
      lastname: {
        error: 'Por favor llene el apellido del administrador.',
        help: 'Este es el apellido del administrador.',
      },
      email: {
        error: 'Por favor complete el correo electrónico del administrador.',
        help: 'Ingrese el correo electrónico o nombre de usuario con el que accederá su administrador, recuerde que un nombre de usuario (no email) no podrá recuperar la contraseña por correo electrónico.',
      },
      password: {
        error: 'La contraseña debe ser de al menos 6 caracteres.',
        help: 'Si no establece una contraseña, le enviaremos un enlace por correo electrónico para cambiar la contraseña. ¡Recuerda usar un correo electrónico válido!',
        create: 'Crear una contraseña',
      },
      privilege: {
        error: 'Seleccione un privilegio para el administrador.',
        help: 'Esto define los permisos del administrador. Puede ser predeterminado o personalizado.',
      },
      passwordConfirm: {
        error: 'Las contraseñas no coinciden.',
      },
    },
    notification: {
      success: {
        patch: 'El administrador {email} fue editado exitosamente.',
        post: 'El administrador {email} fue creado exitosamente. | El administrador {email} fue creado exitosamente, le hemos enviado un correo para la activación.',
      },
      fail: {
        conflict: 'El correo electrónico o nombre de usuario ya está en uso, elija otro.',
        username: 'Si no establece una contraseña, proporcione un correo electrónico válido.\n\n Por el contrario, proporcione una contraseña y nombre de usuario.',
      },
      permissions: 'No tienes permisos para {action} administrador. Si crees que esto está mal, intente nuevamente o contáctenos.',
    },
  },
  fr: {
    title: 'Administrateurs',
    subtitle: 'Liste des administrateurs ayant accès à la création d\'utilisateurs, de départements, d\'intégrations et de métriques.',
    columns: {
      name: 'Nom',
      email: 'E-mail',
    },
    form: {
      firstname: {
        error: 'Veuillez remplir le prénom de l\'administrateur.',
        help: 'C\'est le prénom de l\'administrateur.',
      },
      lastname: {
        error: 'Veuillez remplir le nom de famille de l\'administrateur.',
        help: 'C\'est le nom de famille de l\'administrateur.',
      },
      email: {
        error: 'Veuillez compléter l\'e-mail de l\'administrateur.',
        help: 'Entrez l\'e-mail ou le nom d\'utilisateur avec lequel l\'administrateur se connectera. Notez qu\'un nom d\'utilisateur (non un e-mail) ne pourra pas récupérer le mot de passe par e-mail.',
      },
      password: {
        error: 'Le mot de passe doit comporter au moins 6 caractères.',
        help: 'Si vous ne définissez pas de mot de passe, nous enverrons un lien par e-mail pour changer le mot de passe. Assurez-vous d\'utiliser un e-mail valide !',
        create: 'Créer un mot de passe',
      },
      privilege: {
        error: 'Sélectionnez un privilège pour l\'administrateur.',
        help: 'Cela définit les autorisations de l\'administrateur. Cela peut être par défaut ou personnalisé.',
      },
      passwordConfirm: {
        error: 'Les mots de passe ne correspondent pas.',
      },
    },
    notification: {
      success: {
        patch: 'L\'administrateur {email} a été modifié avec succès.',
        post: 'L\'administrateur {email} a été créé avec succès. | L\'administrateur {email} a été créé avec succès, nous vous avons envoyé un e-mail pour l\'activation.',
      },
      fail: {
        conflict: 'L\'e-mail ou le nom d\'utilisateur est déjà utilisé, veuillez en choisir un autre.',
        username: 'Si vous ne définissez pas de mot de passe, fournissez un e-mail valide.\n\n Sinon, fournissez un mot de passe et un nom d\'utilisateur.',
      },
      permissions: 'Vous n\'avez pas les autorisations pour {action} l\'administrateur. Si vous pensez que cela est incorrect, essayez à nouveau ou contactez-nous.',
    },
}

};
